import { render, staticRenderFns } from "./so_view.vue?vue&type=template&id=65e80a46&scoped=true"
import script from "./so_view.vue?vue&type=script&lang=js"
export * from "./so_view.vue?vue&type=script&lang=js"
import style0 from "./so_view.vue?vue&type=style&index=0&id=65e80a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e80a46",
  null
  
)

export default component.exports